<template>
  <form @submit.prevent="handleSubmit(item)">
    <b-row>
      <b-col>
        <div class="form-group">
          <label
                  for="excmagreementdevice_device"
                  class="form-control-label">{{$t('views.excmdeviceperipheral.form.title')}}:</label>
          <fg-input>
            <el-select
                    id="excmagreementdevice_device"
                    class="select-default"
                    :placeholder="$t('views.excmdeviceperipheral.form.title')"
                    filterable
                    v-model="item.peripheralDevice">
              <el-option v-for="option in devicesOptions"
                         class="select-default"
                         :value="option['@id']"
                         :label="option.title"
                         :key="option['@id']">
              </el-option>
            </el-select>
          </fg-input>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <button type="submit" class="btn btn-success">{{ $t('buttons.submit') }}</button>
        <b-btn variant="danger" @click="closeModal()">{{ $t('buttons.cancel') }}</b-btn>
      </b-col>
    </b-row>
  </form>
</template>

<script>
export default {
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    type: {
      type: Number,
      default: 0
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      devicesOptions: []
    }
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    }
  },

  created () {
    this.getDevices()
    this.channelDevices = this.$store.state.Pusher.subscribe('e_x_c_m_device_peripherals')
    this.channelDevices.bind('e_x_c_m_device_peripherals', data => {
      this.getDevices()
    })
  },

  methods: {
    getDevices () {
      let params = {
        'pagination': false
      }
      this.devicesOptions = []
      this.$http.get('api/e_x_c_m_device_peripherals', {
        params
      })
        .then(response => {
          this.devicesOptions = response.data['hydra:member']
        })
        .catch(error => {
          if (error.response.status === 400) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },
    closeModal () {
      if (this.type === 1) {
        this.$store.state.modals.excmdeviceperipheraldevice.create.close = 1
      } else if (this.type === 2) {
        this.$store.state.modals.excmdeviceperipheraldevice.update.close = 1
      }
    },
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
